import type { RefObject } from "react";

import { usePathname } from "next/navigation";
import { createContext, useContext, useEffect, useRef } from "react";

export const usePreviousPath = () => {
  const context = useContext(PreviousPathContext);
  if (context === undefined) {
    throw new Error("usePreviousPath must be used within an PreviousPathProvider");
  }
  return context;
};

export const PreviousPathProvider = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname();

  const ref = useRef<null | string>(null);

  useEffect(() => {
    // Store current pathname as previous before it changes on next render
    return () => {
      ref.current = pathname;
    };
  }, [pathname]);

  return <PreviousPathContext.Provider value={ref}>{children}</PreviousPathContext.Provider>;
};

const PreviousPathContext = createContext<RefObject<null | string> | null>(null);
